"use client";

import { useEffect, useRef, type ReactNode } from "react";

import { restoreRunPreferences } from "@demo/libs/run-preferences";

export function RunPreferencesProvider({ children }: { children: ReactNode }) {
  const restored = useRef(false);
  useEffect(() => {
    if (restored.current) return;
    restored.current = true;
    restoreRunPreferences();
  }, []);
  return <>{children}</>;
}
